import { combineReducers } from 'redux';
import {
  FETCH_FAQS_REQUEST,
  FETCH_FAQS_SUCCESS,
  FETCH_FAQS_FAILURE,
  FETCH_FAQ_BY_ID_REQUEST,
  FETCH_FAQ_BY_ID_SUCCESS,
  FETCH_FAQ_BY_ID_FAILURE,
} from '../../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_FAQS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_FAQS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_FAQS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_FAQ_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_FAQ_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_FAQ_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const faqs = combineReducers({
  list,
  selected,
});

export default faqs;
